interface LoadingSpinnerProps {
  message?: string;
  size?: 'small' | 'medium' | 'large';
  inline?: boolean; // For use inside buttons
}

export function LoadingSpinner({ message, size = 'medium', inline = false }: LoadingSpinnerProps) {
  const sizeClasses = {
    small: 'w-4 h-4 border-2',
    medium: 'w-8 h-8 border-4',
    large: 'w-12 h-12 border-4',
  };

  if (inline) {
    // Inline variant for buttons - no padding, smaller spinner
    return (
      <div className={`${sizeClasses.small} border-gray-200 border-t-white rounded-full animate-spin inline-block`} />
    );
  }

  return (
    <div className="flex flex-col items-center justify-center gap-4 py-8">
      <div
        className={`${sizeClasses[size]} border-gray-200 border-t-primary-600 rounded-full animate-spin`}
      />
      {message && <p className="text-gray-600 text-center">{message}</p>}
    </div>
  );
}
